import React, {useEffect, useState} from 'react';
import logo_26 from "./Memories_Images/logo.png";
import styles from "./Event_26.module.css";
import Modal from "./Modal"
import Card from "./speakerCard";
import Data from "./speaker26_Data"
import AboutCarousel from './gallerycarousel';
import Teamcard from "./memberCard";
import team from "./team26_Data";

import Maitrayee from "./speakers26/maitrayee.jpeg"
import Harinie from "./speakers26/harinie.jpeg"
import Bhavna from "./speakers26/bhavna.jpeg"
import Abhijeet from "./speakers26/abhijeet.jpeg"
import Sairam from "./speakers26/sairam.jpeg"
import Trigunesh from "./speakers26/trigunesh.jpeg"
import Sparsh from "./speakers26/sparsh.png"
import Salmaan from "./speakers26/salmaan.jpeg"

const Event_26 = () => {
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);

  const openModal = ({name, about, description, image, youtubeLink}) => {
    setSelectedSpeaker({name, about, description,image, youtubeLink});
  };

  const closeModal = () => {
    setSelectedSpeaker(null);
  };

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  return (
    <div>
      <div id={styles.body}>
        <header>
          <div>
            <img src={logo_26} alt="theme logo" />
            <div id={styles.theme}>
              <h1>Theme 2026:</h1>
              <h1>The Ship of Theseus</h1>
            </div>
          </div>
          <h2>February 08, 2026</h2>
        </header>
        <main>
          <div id={styles.banner}>
            <img src={'./images/eventsHome/theme26.png'} alt="theme'26" />
          </div>
          <div id={styles.about}>
            <h2>About</h2>
            <p>
            The theme of TEDxIITGuwahati 2026 is "The Ship of Theseus," a profound exploration of identity, evolution, and what it truly means to endure through change. If every plank of a majestic ship is replaced over time, does it remain the same vessel? And if the original pieces were painstakingly rebuilt into another ship, which one would truly be the "real" original? This ancient paradox challenges us to question what defines identity—is it the material we are made of, the structural form we hold, or the enduring story that continues as we transform? In an era characterized by rapid technological advancement and societal shifts, we are all vessels navigating the unpredictable seas of progress, constantly shedding our old selves and integrating the new.
            However, this continuous cycle of renewal does not signify a loss of self. Instead, it invites a deeper understanding of evolution. Are we bound by the origins of our past, or are we defined by the ongoing process of becoming? This theme speaks to the innovators, the thinkers, and the dreamers who embrace change without losing their core essence. It encourages us to find beauty in adaptation and resilience, reminding us that transformation is not the destruction of who we were, but the expansion of who we can be. The Ship of Theseus teaches us that in the ebb and flow of life, we discover not loss, but a continuous evolution—the essence of identity transcending physical form, carried forward by the ideas and memories that anchor us.
            </p>
          </div>
          <div className={styles.gallery}>
                      <h2>Memories</h2>
                      <div className={styles.galleryContainer}>
                        <AboutCarousel />
                      </div>
                    </div>
          <div id={styles.speakers}>
            <h2>Speakers</h2>
            <div id={styles.speakerContainer}>
            <Card func={() => openModal({ name: 'Dr. Maittrayee Patar', about: 'Musical artist, Poet and Sociologist', description: `${Data.maitrayee}`, image: `${Maitrayee}`, youtubeLink:'PLhmIBvQZeo' })} name='Dr. Maittrayee Patar' id='#Maitrayee' image={Maitrayee} />
            <Card func={() => openModal({name: 'Ms. Harinie Jeevitha',about: 'Bharatanatyam Dancer & Choreographer',description: `${Data.harinie}`,image: `${Harinie}`, youtubeLink:'5Wtu4eknXOM'})} name='Ms. Harinie Jeevitha' id='#Harinie' image={Harinie} />
            <Card func={() => openModal({name: 'Ms. Bhavna Harchandrai',about: 'Fitness Expert & Wellness Entrepreneur',description: `${Data.bhavna}`,image: `${Bhavna}`, youtubeLink:'rCKJ3cCwrNk'})} name='Ms. Bhavna Harchandrai' id='#Bhavna' image={Bhavna} />
            <Card func={() => openModal({name: 'Mr. Abhijeet Anand',about: 'Founder & CEO, abCoffee',description: `${Data.abhijeet}`,image: `${Abhijeet}`, youtubeLink:'eDPyukL73v8'})} name='Mr. Abhijeet Anand' id='#Abhijeet' image={Abhijeet} />
            <Card func={() => openModal({name: 'Dr. Sairam Atluri',about: 'Physician & Regenerative Medicine Pioneer',description: `${Data.sairam}`,image: `${Sairam}`, youtubeLink:'iFmiwxMNIG0'})} name='Dr. Sairam Atluri' id='#Sairam' image={Sairam} />
            <Card func={() => openModal({name: 'Mr. Trigunesh Mukherjee',about: 'Leadership Mentor & Founder, inme',description: `${Data.trigunesh}`,image: `${Trigunesh}`, youtubeLink:'kzLLKqq32vQ'})} name='Mr. Trigunesh Mukherjee' id='#Trigunesh' image={Trigunesh} />
            <Card func={() => openModal({name: 'Dr. Sparsh Johari',about: 'Assistant Professor',description: `${Data.sparsh}`,image: `${Sparsh}`, youtubeLink:'CUVu1lFe43A'})} name='Dr. Sparsh Johari' id='#Sparsh' image={Sparsh} />
            <Card func={() => openModal({name: 'Mr. Salmaan Ahmed',about: 'Student Designer',description: `${Data.salmaan}`,image: `${Salmaan}`, youtubeLink:'aEJgLx_FfmE'})} name='Mr. Salmaan Ahmed' id='#Salmaan' image={Salmaan} />
            </div>
          </div>
          <div id={styles.team}>
            <h2>Organizing Team</h2>
            <div id={styles.teamContainer}>
            {team.map((member) => (
                <Teamcard
                    key={member.id}
                    name={member.name}
                    role={member.role}
                    image={member.image}
                    linkedin={member.linkedin}
                />
            ))}
            </div>
          </div>
        </main>

        {selectedSpeaker && (
          <Modal
            name={selectedSpeaker.name}
            about={selectedSpeaker.about}
            image={selectedSpeaker.image}
            description = {selectedSpeaker.description}
            func={closeModal}
            youtubeLink={selectedSpeaker.youtubeLink}
          />
        )}
        {selectedSpeaker && <div onClick={closeModal} id={styles.overlay}></div>}

      </div>
    </div>
  );
};

export default Event_26;
